import { render, staticRenderFns } from "./EsPrimario.vue?vue&type=template&id=67be77b4&scoped=true&"
import script from "./EsPrimario.vue?vue&type=script&lang=js&"
export * from "./EsPrimario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be77b4",
  null
  
)

export default component.exports